module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2l"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "pt01ch03"
    }
  }, [_vm._v("chapter three")])]), _c('a', {
    attrs: {
      "id": "pt01ch03"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("TGIF! Friday is our weekly sleepover night, and I was currently perched over the edge of Andy’s queen-size bed as I painted my toenails Slutty Red. That wasn’t the “official” name, but whatever.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, so dish, ladies,” Andy said, rubbing the green tea mask—oops, sorry, "), _c('em', [_vm._v("masque")]), _vm._v("—on her face. “Whaddaya think of that Britney girl who Matthew’s suddenly dating? I mean, I never even saw them talk before, and now they’re practically dry humping in the hallway? What’s up with that?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "pt01ch03"
    }
  }, [_vm._v("I stifled a giggle at Andy’s vivid but accurate description of my successful love match. Now that I was a bona fide cupid, I wasn’t even grossed out by couples’ smooshed-against-the-lockers Public Displays of Affection. Matthew and Britney had been locked at the ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("lips ever since I sent the e-mail, and I couldn’t have been happier about the match.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I think it’s gross,” Maya said, her nose wrinkled. She pulled her long, dark hair into her trademark ponytail, grimacing at her reflection in the hand-held mirror.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You would,” Andy teased.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Maya stuck her tongue out at Andy. After dabbing clumps of masque all over her thin, pale face, she continued. “Well, who wants to see people groping like that? Get a room. I’d rather be with a guy who knows how to act like a gentleman.” She paused. “Though at least Britney and Matthew seem to really like each other. They’ve both been beaming all week. What do you think, Felicity?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I swallowed, suddenly nervous. As much as I wanted to ’fess up, I had to play surprised. Which meant lying to my best friends—not a fun task. I was a terrible liar, and I knew they would see right through me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, yeah. I thought it was weird too,” I said, trying to play it cool, even though my hand was shaking. “But definitely great for them.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Damn, I messed up my pinkie toenail. A big glob of Slutty Red clumped on the toe knuckle. “Hey, I need the nail polish remover.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("Luckily, my friends were both too caught up in beautifying ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("themselves to notice my fibbing. Andy tossed me the bottle with the tips of her fingers, trying not to get green tea masque all over the cap. “Here ya go.”")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thanks. Well,” I said casually, “you never know when love will strike.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Maya shot me a weird look. “Speaking of, what’s going on with your job? Have you started yet?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah.” Quickly, I brought into my mind the story I’d rehearsed. “It’s a lot of paperwork so far, but I’ve been learning the fine art of matching profiles by observing some of the pros.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a way, that was true. I’d rented some older movies, like "), _c('em', [_vm._v("Clueless, Emma")]), _vm._v(", and "), _c('em', [_vm._v("The Wedding Planner")]), _vm._v(", to put me in the right frame of mind and maybe give me some ideas.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Maya nodded thoughtfully. “Well, maybe once you’re there for a while, you’ll move up and get to do some of the good stuff.” She grabbed a washcloth and headed into Andy’s bathroom. Yet another reason to be jealous of Andy—she had a full bathroom attached to her room, including a luxurious, claw-footed tub.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mom wouldn’t even let me keep my curling iron in our family bathroom, since she said it junked it up. However, lucky Andy’s girly stuff was strewn all across hers.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("“That sounds cool,” Andy said. “So much better than my stupid job.” She hustled into the bathroom to rinse the masque off her face as well.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("That was one thing about Andy I actually didn’t envy: her job. She works as a waitress at The Burger Butler, one of those cutesy, gimmicky restaurants with a franchise in every big city. Unfortunately, she has to wear a butler uniform when she serves her customers, right down to the white gloves and bow tie. God only knows how many times she’s gotten called “Jeeves” on a daily basis or had her tuxedoed butt grabbed by some pervy old man. She doesn’t have to work—her parents are happy to buy her whatever she wants—but it’s important to Andy to be independent and more self-reliant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah, but at least you get free food,” I pointed out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Like I want more burgers,” Andy said, coming out of the bathroom and patting her face dry with a plush purple towel. “Besides, do you know how bad all that grease is for your complexion? I don’t need any more breakouts.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please. You hardly need to worry about it.” I finished up my toenails. There—picture-perfect. Too bad Derek would never see them. “You have gorgeous skin. Besides, your booty alone is the ultimate guy magnet.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("“If all it takes to get a boyfriend is a big booty, then guys should be knocking down my front door,” Maya said, coming out of the bathroom and flopping on the floor. “But they’d have to notice me first. I’m just way too nervous to talk to them the way Andy does.”")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Oh. My. "), _c('em', [_vm._v("God")]), _vm._v(". I just got the best idea in the world. I could find a love match for Maya! Why didn’t I think of that before?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Maya needed an ego boost, stat, and I had just the magic to make her dreams come true. Besides, it would be way more fun and fulfilling for me than pairing off people I don’t know very well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This was a seriously good use of my new cupid powers. Why shouldn’t my friend have a great boyfriend? If I couldn’t date Derek, at least Maya could be happy. I’d just have to live vicariously through her love life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So, Maya,” I said as nonchalantly as possible, screwing the nail polish lid tightly closed, “what kind of guy are you looking for? I mean, obviously you want someone who appreciates junk in the trunk.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("Maya laughed, stretching her legs out and flexing her toes. “Well, I want a smart guy who’s involved in school activities, like I am. I want someone who respects me and doesn’t just think about how to get in my pants. Someone who likes to have fun. And someone who ")]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("isn’t too macho to hang with me, or to call me to talk.”")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Andy snickered. “So basically, you want Prince Charming.”")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("“Well, I guess having a white horse would be a bonus too.” Maya laughed again and flung the towel at her. “Smart-ass.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("“Pass the potatoes, please,” Rob said, “or I’ll have to arrest you for resisting an officer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My dad chuckled, handing him the bowl of garlic mashed potatoes. “Funny.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So not funny. Rob always cracks way too many stupid cop jokes every time he comes over. My mom insists on my brother joining us every Sunday for family dinner. She says our family needs to keep in constant contact in order to stay close. I guess it’s a carryover from her large Italian family.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Frankly, I think I’d feel closer to Rob if he’d stay farther away.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rob had brought a new “flavor of the week” with him, some fake-blond chick with poofy hair and a poofier chest. I don’t know where he finds these girls, but this one looked like maybe he’d picked her up for prostitution on the way here and decided to bring her to dinner instead of to jail.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("Blondie giggled. “Oh, Robbie, you’re too cute.” She swatted his ")]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("arm with her long, acrylic nails painted neon pink with tiny crystal jewels on the tips.")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I think I just threw up a little in my mouth. “Hey, "), _c('em', [_vm._v("Robbie")]), _vm._v(", can you pass the dinner rolls over here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rob shot me a glare. “Here.” He tossed me the bread basket and kicked me under the table.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Mom,” I whined, ducking a hand under the table to rub my sore shin, “call the child-abuse hotline. I’m being beaten up by my own brother. And a cop, too. For shame—always sad when the good ones turn bad like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This time, "), _c('em', [_vm._v("she")]), _vm._v(" gave me the evil eye. I shut my mouth. Some people just don’t appreciate genuine humor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So,” Mom said, turning her attention to Fluffykins, or whatever her name was (I didn’t bother to learn them anymore, since women came and went out of my brother’s life with alarming speed), “where did you say you and Rob met?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We met on LoveMatesForever.com,” she said around a spoonful of mashed potatoes. “I thought he was so dreamy. Plus, he wasn’t, like, forty or anything. I’m sooooooo tired of those old guys hitting on me.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("My dad nearly choked on his bread roll. I bit back a laugh. "), _c('em', [_vm._v("Nice")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('em', [_vm._v("job, dumb-ass.")]), _vm._v(" In one fell swoop she’d insulted both my parents, who were in their early forties.")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Hey, if things didn’t work out for Rob and Fluffykins—and that was a sure bet, because things "), _c('em', [_vm._v("never")]), _vm._v(" worked out for him—maybe I could use my matchmaking skills to find him a real girlfriend. But then I’d have to get close enough to him to observe him, and that would seriously bite. There are only so many times a day a girl can be called “butthead” by her brother before wanting to kick him in the joeys.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did you know Felicity works for a matchmaking company?” my mom said, trying hard to keep her polite smile in place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oh, crap. I should have seen that one coming.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No way!” Bleach Blonde squealed, her bright red lips flying open. “Which one? I’ve joined, like, every one out there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rob shifted in his seat. I guess I’d feel uncomfortable too, if my date continued with the rampant stupidity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, it’s a little one,” I replied. “I doubt you’ve heard of it. I just started, so I’m not doing any of the good stuff yet. Mostly paperwork.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She squinted her heavily lined eyes at me. “Try me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Cupid’s Hollow.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("“Oh.” She scooped another pile of potatoes on her fork. “Never heard of it.” After chewing a bite, she glanced at Rob, then patted his hand. “Guess I don’t need to worry about that now, do I, Snookie?” "), _c('em', [_vm._v("Giggle, giggle.")])])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I shoveled the rest of my dinner down fast. I had to get out of there, now. “Excuse me,” I said, carrying my plate into the kitchen before anyone could beckon me back. “Gotta go do some homework.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That was one good thing about still being in school—I always had homework to serve as a ready-made excuse for getting out of crappy family events.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Up in my room, I picked up the PDA and flipped through the many, many entries I’d made yesterday, trying to find the perfect match for Maya. There were a few candidates who seemed good and who met the minimum-compatibility requirements, but I still wasn’t sure who to choose. I resolved to follow the top candidates around for a day so I could observe them as much as possible and find the perfect one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After all, we weren’t talking about any old target here. This was one of my best friends!")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("•")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("Monday morning, I was rarin’ to go. The first thing I did after stepping inside the front doors of Greenville High was flip on my PDA and run through the entire male population of the junior and senior classes about a billion times. After much scrutiny, I finally narrowed the candidates for Maya down to three possibilities: Josh Wiley, the drum major of the band; Ben Johnson, the announcer for the school’s basketball games; and Quentin Lovejoy, the editor-in-chief of the yearbook.")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("All three of those guys were highly involved in school activities, one of Maya’s big criteria, and just as importantly, I’d never heard complaints from other girls about them being total buttheads. Plus, they were all cute and smart, so putting them at the top of the lineup made total sense.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Therefore, my mission was to pay special attention to these three lead candidates for Operation Hook Maya Up and determine who was most worthy of my friend’s affection.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As I gathered further profile data throughout the day, watching the guys closely, my initial thoughts were confirmed. All three would be great for Maya. The more I observed of the three of them, the harder it was to choose among them.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("In art class, my last class of the day, I sat in the back corner, ")]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("doodling absentmindedly on the corner of my latest project, a pencil sketch of a pile of books. I was too wrapped up in matchmaking Maya to even stare at Derek’s gorgeous face from under the shield of my eyelashes, like I normally did (although he did acknowledge me in class today with a nod and smile). I needed to figure out which guy would be the best choice for Maya, but the decision was overwhelming me.")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("How could I pick just one of them?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then, still staring at the books in my drawing, I had a sudden realization. Maybe it wasn’t fair of me to make the choice for her—didn’t Maya have a right to choose for herself which guy she liked best? I stopped doodling and pulled out my PDA, nestling it in my lap, then turned it on and opened up the e-mail program.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I typed in Maya’s e-mail address and then carbon copied Josh, Ben, "), _c('em', [_vm._v("and")]), _vm._v(" Quentin. Matching all of them up like this was so against the rules—but then again, didn’t Janet tell me to trust my gut? Surely the “gut” clause trumped the so-called “rules”—right?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And my gut was saying loud and clear, “Hedge your bets, Felicity! Send it to them all.” I mean, what are friends for?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Time for Maya, with a little help from me, to get the kind of attention she deserved. Drawing in a deep breath, I hit send.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5862b4b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/pt01ch03.vue
// module id = 81
// module chunks = 0